import Button from '@/components/UI/Button';
import { HookCheckboxGroup } from '@/components/UI/HookForm/Form/CheckBoxGroup';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import HookMaskedInput from '@/components/UI/HookForm/Form/MaskedInput';
import { HookRadioGroup } from '@/components/UI/HookForm/Form/RadioGroup';
import { cityEmployeeOptions, genderOptions, raceOptions } from '../constants';

interface HomeownerInformationProps {
  onNext: () => void;
}

export const HomeownerInformation = ({ onNext }: HomeownerInformationProps) => {
  return (
    <div className='p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden'>
      <div>
        <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Homeowner Information</h3>
        <p className='mt-2 text-sm text-gray-600'>
          Please provide information about the buyer and every household member aged 18 or older.
        </p>
      </div>

      <div className='grid grid-cols-6 gap-6'>
        <HookInput
          customClassName='col-span-6 sm:col-span-4'
          label='Name'
          name='homeownerInformation.name'
          type='text'
          placeholder='Full name'
        />

        <HookMaskedInput
          customClassName='col-span-6 sm:col-span-3'
          label='Phone'
          name='homeownerInformation.phone'
          maskedComponent='phone'
        />

        <HookInput
          customClassName='col-span-6 sm:col-span-3'
          label='Email'
          name='homeownerInformation.email'
          type='email'
          placeholder='email@example.com'
        />

        <HookInput
          customClassName='col-span-6'
          label='Current Address'
          name='homeownerInformation.currentAddress'
          type='text'
          placeholder='Street address, city, state, zip'
        />

        <HookInput
          customClassName='col-span-6'
          label='Address of Property Being Purchased'
          name='homeownerInformation.propertyAddress'
          type='text'
          placeholder='Street address, city, state, zip'
        />

        <HookInput
          customClassName='col-span-6 sm:col-span-3'
          label='Purchase Price'
          name='homeownerInformation.purchasePrice'
          type='text'
          placeholder='$0.00'
        />

        <HookRadioGroup
          className='col-span-6 sm:col-span-3'
          label='Gender'
          name='homeownerInformation.gender'
          id='homeownerInformation.gender'
          options={genderOptions}
        />

        <div className='col-span-6'>
          <HookCheckboxGroup
            label='Race (select all that apply)'
            name='homeownerInformation.race'
            options={raceOptions.map((race) => ({
              label: race,
              value: race,
            }))}
          />
        </div>

        <HookRadioGroup
          className='col-span-6'
          label='City Employee (Y/N)'
          name='homeownerInformation.cityEmployee'
          id='homeownerInformation.cityEmployee'
          options={cityEmployeeOptions}
        />
      </div>

      <div className='flex gap-4 justify-end mt-5'>
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
};
